import axios from "./../../axiosMiddleware/index";
import { api } from "../../apiendpoints/index";

export const GetAllDocuments = async (data) => {
  return axios.post(`${api.DOCUMENT_MANAGEMENT.GET_ALL_DOCUMENTS}`, data);
};

export const GetECNChange = async () => {
  return axios.get(`${api.DOCUMENT_MANAGEMENT.GET_USER_AND_DROPDOWN_DATA}`);
};

export const GetAssociatedDocuments = async () => {
  return axios.get(`${api.DOCUMENT_MANAGEMENT.GET_ASSOCIATED_DOCUMENTS}`);
};

export const GetPropertiesData = async () => {
  return axios.get(`${api.DOCUMENT_MANAGEMENT.GET_USER_AND_DROPDOWN_DATA}`);
};

export const GetDocumentEmployee = async (
  value,
  config = {}
) => {
  return axios.get(
    `${api.DOCUMENT_MANAGEMENT.GET_EMPLOYEE_BY_DEPARTMENT}?DepartmentName=${value}`,
    config
  );
};

export const AddOrEditDocuments = async (FormData) => {
  return axios.post(
    `${api.DOCUMENT_MANAGEMENT.ADD_OR_EDIT_DOCUMENT}`,
    FormData
  );
};

export const GetDocumentDetailById = async (documentId, documentIdCombinedWithType) => {
  return axios.get(
    `${api.DOCUMENT_MANAGEMENT.GET_DOCUMENT_BY_ID}?Id=${documentId}&DocumentId=${documentIdCombinedWithType}`
  );
};

export const DownloadPdfDocument = async (documentId, documentIdCombinedWithType) => {
  return axios.get(
    `${api.DOCUMENT_MANAGEMENT.DOWNLOAD_PDF_DOCUMENT}?Id=${documentId}&DocumentId=${documentIdCombinedWithType}`
  );
};

export const ApproveDocuments = async (data) => {
  return axios.post(`${api.DOCUMENT_MANAGEMENT.APPROVE_DOCUMENT}`, data);
};
